import React from "react";
import { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Traslates, SimpleLoading } from "../../pures";
import { DialogSystemGLPure } from '../../pures';
import "./grid-list-signers.css";
import './notify-button.css'
import { NotificationResendService } from "../../../services";
import { useMediaQuery } from "@material-ui/core";


/* === Custom Component for th elements of the Grid === */
const signerCellHeader = (props) => {
  const cellHeaderStyles = {
    color: "#123513",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    justifyContent: "start",
    fontFamily: "Quicksand, sans-serif",
  };
  return <span style={cellHeaderStyles}>{props.title}</span>;
};


/* === Custom componente for td elements of the Grid === */
const signerCell = (props) => {
  const cellItemStyles = {
    color: "#000000",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand, sans-serif",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};
const signerCellDate = (props) => {
  const cellItemStyles = {
    color: "#000000",
    fontSize: "16px",
    fontWeight: 550,
    textTransform: "capitalize",
    fontFamily: "Quicksand, sans-serif",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};

/* === Custom componente cells SignStatus for td elements of the Grid === */
const signerStatusSignCell = (props) => {
  let colorItem = "";
  if (props.dataItem.signStatusId) {
    if (props.dataItem.signStatusId === 2) {
      colorItem = "#005EA0";
    } else if (props.dataItem.signStatusId === 4) {
      colorItem = "#899232";
    } else if (props.dataItem.signStatusId === 3) {
      colorItem = "#F86A65";
    } else {
      colorItem = "#4c4c4c";
    }
  }
  const cellItemStyles = {
    color: "#4c4c4c",
    fontSize: "16px",
    fontWeight: 550,
    textTransform: "uppercase",
    fontFamily: "Quicksand, sans-serif",
  };
  return (
    <td style={cellItemStyles}>
      <span style={{ color: `${colorItem}` }}>
        {props.dataItem[props.field]}
      </span>
    </td>
  );
};

/* === Custom componente cells SignStatus for td elements of the Grid === */
const signerCellTypeName = (props) => {
  const cellItemStyles = {
    color: "#000000",
    fontSize: "16px",
    fontWeight: 550,
    textTransform: "uppercase",
    fontFamily: "Quicksand, sans-serif",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};




const GridListSigners = (props) => {
  const { t } = useTranslation();
  const [loadingRequest, setLoadingRequest] = useState(false)
  const [completedRequest, setCompletedRequest] = useState(false)
  const isMobile = useMediaQuery("(max-width:650px)");
  const gridLabelNorecordsStyles = {
    color: "#828282",
    fontSize: "16px",
    fontWeight: 500,
    fontFamily: "Quicksand, sans-serif",
  };

  const notifyClient = async (signRequestId, email) => {
    setLoadingRequest(true)
    const token = JSON.parse(localStorage.getItem("token"))
    let notifService = new NotificationResendService(process.env.REACT_APP_MIFIRMA_API)
    let sendNotify = await notifService.resendNotification(signRequestId, email, token.idToken)
    if (sendNotify && sendNotify.statusCode === 200) {
      setLoadingRequest(false)
      setCompletedRequest(true)
      setTimeout(() => {
        setCompletedRequest(false)
      }, 3000)
    }
  }

  const signerResend = (props) => {
    if (props.dataItem.signStatusId === 2) {
      return <td><button className='notify-button' onClick={() => { notifyClient(props.dataItem.signRequestId, props.dataItem.email) }}>Notificar</button></td>;
    } else {
      return null
    }
  };

  return (
    <div>
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Traslates>
          <DialogSystemGLPure showLoadingRequesting={loadingRequest} toggleLoadingRequesting={() => setLoadingRequest(false)} toggleCompletedRequesting={() => setCompletedRequest(false)} showCompletedRequesting={completedRequest} />

          <Grid
            className="listSignerSignature"
            data={props.signRequestSigners.slice(
              props.skip,
              props.take + props.skip
            )}
            resizable
            reorderable
          >
            {!isMobile ?
              <GridColumn
                field="name"
                title={t("gridListSigners.titleName")}
                width="auto"
                cell={signerCell}
                headerCell={signerCellHeader}
              />
              : ""}
            {!isMobile ?
              <GridColumn
                field="email"
                title={t("gridListSigners.titleEmail")}
                width="auto"
                cell={signerCell}
                headerCell={signerCellHeader}
              />
              : <GridColumn
                field="email"
                title={t("gridListSigners.titleEmail")}
                width="100"
                cell={signerCell}
                headerCell={signerCellHeader}
              />
            }
            {!isMobile ?
              <GridColumn
                field="signerTypeName"
                title={t("gridListSigners.titleRole")}
                width="auto"
                cell={signerCellTypeName}
                headerCell={signerCellHeader}
              />
              : ""}
            {!isMobile ?
              <GridColumn
                field="signedDate"
                title={t("gridListSigners.singedDate")}
                width="auto"
                cell={signerCellDate}
                headerCell={signerCellHeader}
              />
              : ""}
            <GridColumn
              field="signStatusName"
              title={t("gridListSigners.titleSignStatus")}
              width="auto"
              headerCell={signerCellHeader}
              cell={signerStatusSignCell}
            />
            {props?.signRequest?.user?.email === props.emailUser && props?.signRequest?.signRequestStatus?.id === 2 ?
              <GridColumn
                field="signRequestId"
                title={t("newSignatureDetailView.column.actions")}
                width="auto"
                headerCell={signerCellHeader}
                cell={signerResend}
              />
              : null}
            <GridNoRecords>
              <p style={gridLabelNorecordsStyles}>
                {t("gridListSigners.noDataToShow")}
              </p>
            </GridNoRecords>
          </Grid>
        </Traslates>
      )}
    </div>
  );
};
export { GridListSigners as default };
